import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { stringify } from 'qs';
import config from '../Config';

const baseURL = config.apiUrl || __API_URL__;
const apiTimeout = 10000;
const pollApiTimeout = 180000;

const paramsSerializer = { serialize: (params: any) => stringify(params, { arrayFormat: 'repeat' }) };

const apiConfig: AxiosRequestConfig = {
  baseURL,
  paramsSerializer,
  timeout: apiTimeout,
  withCredentials: true,
};

const pollApiConfig: AxiosRequestConfig = {
  baseURL,
  paramsSerializer,
  timeout: pollApiTimeout,
  withCredentials: true,
};

export const resolveSsoOrigin = (): string => {
  if (window.location !== window.parent.location) {
    return window.location.ancestorOrigins?.[0] || document.referrer;
  }
  return `${window.location.origin}${window.location.pathname}`;
};

const ssoOriginInterceptor = (config: InternalAxiosRequestConfig) => {
  const ssoOrigin = resolveSsoOrigin();
  if (ssoOrigin) {
    config.headers['X-Sso-Origin'] = ssoOrigin;
  }
  return config;
};

let API = axios.create(apiConfig);
let POLL_API = axios.create(pollApiConfig);
API.interceptors.request.use(ssoOriginInterceptor);
POLL_API.interceptors.request.use(ssoOriginInterceptor);

const reInit = (baseUrl: string) => {
  API = axios.create({ ...apiConfig, baseURL: baseUrl, withCredentials: true });
  POLL_API = axios.create({ ...pollApiConfig, baseURL: baseUrl, withCredentials: true });
  API.interceptors.request.use(ssoOriginInterceptor);
  POLL_API.interceptors.request.use(ssoOriginInterceptor);
};

enum FetchStatus {
  FETCHING = 'FETCHING',
  FETCHING_MORE = 'FETCHING_MORE',
  ERROR = 'ERROR',
  FETCHED = 'FETCHED',
  UNINITIALIZED = 'UNINITIALIZED',
  NOT_FOUND = 'NOT_FOUND',
}

enum PasskeyErrorType {
  USER_CANCELLED = 'USER_CANCELLED',
  GENERAL = 'GENERAL',
}

export interface ErrorResponse {
  errorMessage?: string;
  errorCode?: string;
  softProfile?: boolean;
}

export default API;
export { API, POLL_API, FetchStatus, PasskeyErrorType, reInit, ssoOriginInterceptor };
